(function (appComponents) {

	appComponents.services.header = function (Components) {

		var header = {};

		header.name = "header";

		Components.getComponentPrototype().extend(header);

		header._b2bUnit = header._getService("b2bUnit");
		header._modals = header._getService("modals");
		header._helpers = header._getService("helpers");

		header.elements = {
			get category() {
				return $("[pc-container='header--category-list']");
	         },
	         get inventory() {
					return $("[pc-container='header--inventory-list']");
		         },
			get navigationBar() {
				return $("section[pc-container='navigation-bar']");
			},
			get checkoutProfileOption() {
				return $("[pc-container='header--checkout-profile-option']");
			},
			get loginToPartsPlus() {
				return $('[pc-container="header--parts-plus-login-link"]');
			},
			get advancedSearchTopBar() {
				return $('.adv-searchicon');
			},
			get systemComponents() {
				return $('[pc-container="system--components--li"]');
			},
			get lvMotorsDropDown() {
				return $('.lv-motors-dropdown');
			}
		};

		header.bindings = function () {

		};

		header.liveBindings = function () {
			header.elements.loginToPartsPlus.click(function (e) {
				e.stopImmediatePropagation();
				e.preventDefault();
				header.handlers.onPartsPlusLogin();
			});

			// from td core

			$('body').click(function () {
				if ($('.nav-dropdown').hasClass('open')) {
					$('.caret-twist-pro').addClass('fa-caret-down').removeClass('fa-caret-up');
				} else if ($('.user-profile').hasClass('open')) {
					$('.caret-twist').addClass('fa-caret-down').removeClass('fa-caret-up');
				} else if ($('.adv-searchicon').hasClass('open')) {
					$('.caret-twist-main').addClass('fa-caret-down').removeClass('fa-caret-up');
				}
			});

			$('ul.dropdown-menu [data-toggle=dropdown]').off().on('click', function (event) {
				event.preventDefault();
				event.stopPropagation();
				$(this).parent().siblings().removeClass('open');
				$(this).parent().toggleClass('open');
			});

			$('.caret-twist').parent().click(function () {
				$('.caret-twist').toggleClass('fa-caret-down fa-caret-up');

			});
			$('.caret-twist-pro').parent().click(function () {
				$('.caret-twist-pro').toggleClass('fa-caret-down fa-caret-up');
			});

			$('.caret-twist-main').parent().click(function () {
				$('.caret-twist-main').toggleClass('fa-caret-down fa-caret-up');
			});
		};

		header.renderHeader = function () {
			var html = header.templates.main(header.context);
			header._elements.header.replaceWith(html);
		};
		
		header.b2bUnitOnLoad = function () {
			var unitType = header._b2bUnit.unitType;
			if (unitType == "SAP") {
				header.elements.advancedSearchTopBar.hide();
				header.elements.systemComponents.show();
				header.elements.lvMotorsDropDown.hide();
				header.elements.loginToPartsPlus.hide();
			} else if (unitType == "ORACLE"){
				header.elements.advancedSearchTopBar.show();
				header.elements.systemComponents.hide();
				header.elements.lvMotorsDropDown.show();
				header.elements.loginToPartsPlus.show();
			}
		};

		header.updateNavigationBar = function () {
			var pageTitle = header._page.title;
			header.elements.navigationBar.find("li").removeClass("active").siblings("[pc-value='page-" + pageTitle + "']").addClass("active");
		};

		header.sapCheckRoutine = function () {
			var unitType = header._b2bUnit.unitType;
			if (unitType == "SAP") {
				header.elements.checkoutProfileOption.hide();
				header.elements.advancedSearchTopBar.hide();
				header.elements.systemComponents.show();
				header.elements.lvMotorsDropDown.hide();
				header.elements.loginToPartsPlus.hide();
			} else if (unitType == "ORACLE"){
				header.elements.checkoutProfileOption.show();
				header.elements.advancedSearchTopBar.show();
				header.elements.systemComponents.hide();
				header.elements.lvMotorsDropDown.show();
				header.elements.loginToPartsPlus.show();
			}
		};
		
		header.updateConsolidatedFilters = function () {
			header._api.searchResults.getSubCategoriesForCode("rmcategory_BrowseCatalog").then(function(res){
                header.context.consolidatedFiltersLV = res.body; 
                console.log("header.context.consolidatedFiltersLV",header.context.consolidatedFiltersLV);
                var html = header.templates.categoryList(header.context);
                header.elements.category.html(html);
                var inventory_list = header.templates.inventoryList(header.context);
                header.elements.inventory.html(inventory_list);
                header._bindings();
			});
		};

		header.partsPlusCheckRoutine = function () {
			if (!header._b2bUnit.isUnitSet) {
				header.elements.loginToPartsPlus.attr("href", "javascript:void(0)");
			} else {
				var ssoID="";
				if(header._config.user.id)
					{
					var sso_RM=header._config.user.id;
					ssoID=sso_RM.substring(3);
					}
				var query = {
					CSRFToken: header._config.token,
					customerIndex: header._b2bUnit.currentUnit.uid,
					sm_ssoid:ssoID
				};
				var url = header._links.loginToPartsPlus + "?" + $.param(query);
				header.elements.loginToPartsPlus.attr("href", url);
			}
		};

		header.handlers = {
			onPartsPlusLogin: function () {
				if (!header._b2bUnit.isUnitSet) {
					header._modals.warning.show(header._messages.noB2bUnitSelected);
					return;
				}
				var ssoID="";
				if(header._config.user.id)
				{
				var sso_RM=header._config.user.id;
				ssoID=sso_RM.substring(3);
				}
				var query = {
					CSRFToken: header._config.token,
					customerIndex: header._b2bUnit.currentUnit.uid,
					sm_ssoid:ssoID
				};
				var url = header._links.loginToPartsPlus + "?" + $.param(query);
				header._helpers.clickAnchorLink(url);
			},
			onAppInitialized: function () {
				header.sapCheckRoutine();
				header.partsPlusCheckRoutine();
			},
			onControllerInitialized: function () {
				header.updateNavigationBar();
			},
			onB2bUnitChange: function () {
				header.sapCheckRoutine();
				header.partsPlusCheckRoutine();
			}
		};

		header.init = function () {
			header.context.cartSize = header._stash.cart.size;
			header.updateConsolidatedFilters();
			if (header._b2bUnit.isUnitSet) {
				header.context.unitType = header._b2bUnit.unitType;
			}

			header.renderHeader();
			header._bindings();
			
			header._events.registerHandler("controllerInitialized", header.name, header.handlers.onControllerInitialized);
			header._events.registerHandler("appInitialized", header.name, header.handlers.onAppInitialized);
			header._events.registerHandler("b2bUnitChanged", header.name, header.handlers.onB2bUnitChange);
			
			header.b2bUnitOnLoad();

		};

		return header;

	};

	window.appComponents = appComponents;

})(window.appComponents || {});